export enum TechnicalOrderOrderedDroppableIds {
  TECHNICAL_ORDER_HIGH_PRIORITY_EMPTY = 'TECHNICAL_ORDER_HIGH_PRIORITY_EMPTY',
  TECHNICAL_ORDER_HIGH_PRIORITY = 'TECHNICAL_ORDER_HIGH_PRIORITY',

  TECHNICAL_ORDER_NORMAL_PRIORITY_EMPTY = 'TECHNICAL_ORDER_NORMAL_PRIORITY_EMPTY',
  TECHNICAL_ORDER_NORMAL_PRIORITY = 'TECHNICAL_ORDER_NORMAL_PRIORITY',
}
